import { render, staticRenderFns } from "./TotalResult.vue?vue&type=template&id=44805fc6&scoped=true"
import script from "./TotalResult.vue?vue&type=script&lang=js"
export * from "./TotalResult.vue?vue&type=script&lang=js"
import style0 from "./TotalResult.vue?vue&type=style&index=0&id=44805fc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44805fc6",
  null
  
)

export default component.exports